import { ILocalization, ILocalizationToken } from '../../../application/language/ILocalization';
import { extensionContainer } from '../../../common/container/ContainerContext';
import { inject } from '../../../common/container/inject';
import { IRestService, RestServiceToken } from '../../common/rest/IRestService';
import { WrongCredentialError } from '../activeUser/error/WrongCredentialError';
import { IAccountService } from './IAccountService';

export type UpdatePasswordDTO = {
  newPassword: string;
  confirmPassword: string;
  oldPassword?: string;
}

export class RestAccountService implements IAccountService {
  constructor(protected restService: IRestService = inject<IRestService>(RestServiceToken)) {}

  async getUserSourceType(): Promise<any> {
    try {
      const res = await this.restService.get<any, any>(this.makeUrl('/account/user-source-type'));
      return res
    } catch (error) {
      this.errorHandler(error);
    }
  }

  async updatePassword({ newPassword, confirmPassword, oldPassword}: UpdatePasswordDTO): Promise<any> {
    try {
      await this.restService.post<any, any>(this.makeUrl('/account/change-password'), { newPassword, confirmPassword, oldPassword });
    } catch (error) {
      this.errorHandler(error);
    }

    return true;
  }

  async forceChangePassword({ newPassword, confirmPassword}: UpdatePasswordDTO): Promise<any> {
    try {
      await this.restService.put<any, any>(this.makeUrl('/account/password'), { newPassword, confirmPassword });
    } catch (error) {
      this.errorHandler(error);
    }

    return true;
  }

  

  makeUrl(uri: string) {
    const domain = this.restService.getConfig().url.api.public;
    return `${domain}${uri}`;
  }

  errorHandler = (error: any) => {
    if (error?.webCode && error?.webCode === '404') {
      const i18n: ILocalization = extensionContainer.getByToken(ILocalizationToken);
      throw new WrongCredentialError([
        {
          message: i18n.translate('login.incorrectValid'),
          target: 'login',
        },
      ]);
    } else {
      throw error;
    }
  };
}
